import { usePostHog } from '@posthog/react'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Fires a PostHog `$pageview` event on every HashRouter navigation.
 * PostHog's autocapture handles clicks/interactions; this fills in the
 * route-change gap that hash-based routing creates (the browser never
 * fires a real page load on hash transitions).
 *
 * Place this component anywhere inside <HashRouter> — it renders nothing.
 */
export function PostHogPageView() {
  const location = useLocation()
  const posthog = usePostHog()

  useEffect(() => {
    if (posthog) {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
        hash_path: location.pathname,
      })
    }
  }, [location.pathname, posthog])

  return null
}
